<template>
        <ion-page>
            <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>My Sent IOU Back Requests</ion-title>
            </ion-toolbar>
            </ion-header>
            
            <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                <ion-title size="large">My Sent IOU Back Requests</ion-title>
                </ion-toolbar>
            </ion-header>
            
            <div id="container">
                <DataTable :loading="loading" class="p-datatable-sm" showGridlines :value="iouBackRequests" :lazy="true" :paginator="true" :rows="perPage" :totalRecords="total"  @page="onPage($event)" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                    <template #loading>
                        Loading data, please wait...
                    </template>
                    <template #empty>
                        No records found
                    </template>
                    <Column field="id" header="ID"></Column>
                    <Column field="amount" header="Amount"></Column>
                    <Column field="to" header="To"></Column>
                    <Column field="createdAt" header="Created At"></Column>
                    <Column field="status" header="Status">
                    <template #body="{data}">
                        <!-- {{data.status}} -->
                        <div v-html="data.status"></div>
                    </template>
                    </Column>
                </DataTable>
            </div>
            </ion-content>
        </ion-page>
</template>

<script >
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/vue';
import { defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default defineComponent({
  name: 'My Sent IOU Requests',
  data(){
      return {
          iouBackRequests:[],
          loading:false,
          perPage:10,
          total:0,
      }
  },
  mounted(){
      this.loadData(0);
  },
  methods:{
      async loadData(page){
          const data={
              'page':page + 1,
              'username':window.localStorage.username,
              'password':window.localStorage.password,
          };
          this.loading=true;
        this.$http.post('mySentIOUBackRequests',data).then(response=>{
            // const rows=[];
            this.perPage=response.data.per_page;
            this.total=response.data.total;
            const reqs=[];
            for(const req of response.data.data){
                reqs.push({
                    id:req.id,
                    amount:req.amount,
                    to:req.submit_to.name,
                    createdAt: req.created_at,
                    iouStatus: req.status,
                    status:req.status!="Pending"? req.status+"<br>At: "+req.approved_or_declined_at +(req.status=="Declined"?"<br>Reason: "+req.declined_reason:"") : req.status,
                });
            }
            this.iouBackRequests=reqs;
            this.loading=false;
        });

      },
      onPage(event){
          this.loadData(event.page);
      },

  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    DataTable,
    Column
  }
});
</script>

<style scoped>
.dataRow:nth-child(even){
    background-color: #f2f2f2 !important;
}
</style>